module.exports = __webpack_public_path__ + "static/media/ccPiscacucho.5681ae34.svg";